import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller(
            'HousingAssociationController',
            HousingAssociationController
        );

    /** @ngInject */
    function HousingAssociationController(
        AuthFactory,
        AgreementsDialogService,
        $state
    ) {
        var vm = this;

        init();

        function init() {
            readMe();
        }

        function readMe() {
            AuthFactory.readMe().then(
                function (response) {
                    vm.dataFromBackendForDisplayName = response.data;

                    if (
                        AgreementsDialogService.checkIsNewRule(
                            response.data.last_tos_change,
                            response.data.tos
                        )
                    ) {
                        AgreementsDialogService.openAgreement(
                            'termsDialog',
                            'TermsDialogController',
                            'TermsDialogCtrl',
                            '../assets/documents/RegulaminiWykonawca.pdf'
                        );
                    }
                },
                function () {
                    $state.go('login');
                }
            );
        }
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/_housing_association/housing_association.controller.ts